/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const AddressBookRelationships = {
  Vendor: 'Vendor',
  Customer: 'Customer'
};

export default AddressBookRelationships;